
export const AlarmMachineStatus = ({ color }: { color?: string }): JSX.Element => {
  color = color || '#BA4E00';

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7252_14677)">
        <path
          d="M8.99984 10H9.33317C9.68679 10 10.0259 10.1405 10.276 10.3905C10.526 10.6406 10.6665 10.9797 10.6665 11.3334M10.6665 11.3334V12C10.6665 12.3536 10.526 12.6928 10.276 12.9428C10.0259 13.1929 9.68679 13.3334 9.33317 13.3334H3.99984C3.64622 13.3334 3.30708 13.1929 3.05703 12.9428C2.80698 12.6928 2.6665 12.3536 2.6665 12V11.3334C2.6665 10.9797 2.80698 10.6406 3.05703 10.3905C3.30708 10.1405 3.64622 10 3.99984 10H4.33317M10.6665 11.3334C11.2498 11.2556 11.8071 11.0433 12.2943 10.7134C12.7816 10.3834 13.1855 9.94477 13.4743 9.43202C13.763 8.91928 13.9287 8.34646 13.9582 7.75874C13.9878 7.17102 13.8804 6.58447 13.6445 6.04535L13.3332 5.33335M6.6665 6.66669V6.67335M2.6665 6.66669C2.6665 7.72755 3.08793 8.74497 3.83808 9.49511C4.58822 10.2453 5.60564 10.6667 6.6665 10.6667C7.72737 10.6667 8.74479 10.2453 9.49493 9.49511C10.2451 8.74497 10.6665 7.72755 10.6665 6.66669C10.6665 5.60582 10.2451 4.58841 9.49493 3.83826C8.74479 3.08811 7.72737 2.66669 6.6665 2.66669C5.60564 2.66669 4.58822 3.08811 3.83808 3.83826C3.08793 4.58841 2.6665 5.60582 2.6665 6.66669ZM12.6665 5.33335C12.6665 5.51016 12.7367 5.67973 12.8618 5.80476C12.9868 5.92978 13.1564 6.00002 13.3332 6.00002C13.51 6.00002 13.6796 5.92978 13.8046 5.80476C13.9296 5.67973 13.9998 5.51016 13.9998 5.33335C13.9998 5.15654 13.9296 4.98697 13.8046 4.86195C13.6796 4.73693 13.51 4.66669 13.3332 4.66669C13.1564 4.66669 12.9868 4.73693 12.8618 4.86195C12.7367 4.98697 12.6665 5.15654 12.6665 5.33335Z"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7252_14677">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlarmMachineStatus;
